import React from 'react'
import { CircleOffIcon } from 'lucide-react'

import { cn } from '@/lib/utils.ts'

export interface EmptyProps {
  title?: React.ReactNode
  className?: string
}

export const Empty: React.FC<EmptyProps> = ({
  title = 'Nessun dato disponibile',
  className,
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-2 py-10',
      className
    )}
  >
    <CircleOffIcon className="size-8 text-gray-500" />

    <div className="space-y-2 text-center">
      <h2 className="text-sm">{title}</h2>
      {/*<p className="text-gray-500"></p>*/}
    </div>
  </div>
)
